import {
    Box,
    chakra,
    Container,
    Link,
    Grid,
    Stack,
    Text,
    VisuallyHidden,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
  
 
  
  const SocialButton = ({
    children,
    label,
    href,
  }) => {
    return (
      <chakra.button
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        w={8}
        h={8}
        cursor={'pointer'}
        as={'a'}
        href={href}
        display={'inline-flex'}
        alignItems={'center'}
        justifyContent={'center'}
        transition={'background 0.3s ease'}
        _hover={{
          bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
        }}>
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
      </chakra.button>
    );
  };
  
  const ListHeader = ({ children }) => {
    return (
      <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
        {children}
      </Text>
    );
  };
  
  export default function Footer() {
    return (
      <Box
        bg='#1F1F29'
        color='#fff' w='full' h={['100%','100%','100%','40vh']}>
        <Container as={Stack} maxW={'6xl'} py={10}>
          <Grid
            templateColumns={['repeat(2,1fr)','repeat(2,1fr)','repeat(3,1fr)','repeat(6,1fr)']}
            placeItems='center'
            display='flex'
            fontFamily='Work Sans'
            justifyContent={['space-between','space-evenly']}
            alignItems='flex-start'
            flexWrap={['wrap','nowrap']}
            gap={[12,6,6,0]}
            spacing={8}>
            <Stack align={'flex-start'} w={['100%','40']} justify='center' spacing={6}>
              <Box>
                <Text fontFamily='Duplicate Sans' fontSize='24px' fontWeight='500'>Neemble Pay</Text>
              </Box>
              <Stack direction={'row'} spacing={3}>
                <SocialButton  label={'Twitter'} href={'#'}>
                  <FaTwitter fontFamily='Duplicate Sans' fontSize='24px' fontWeight='500'/>
                </SocialButton >
                <SocialButton  label={'YouTube'} href={'#'}>
                  <FaYoutube fontFamily='Duplicate Sans' fontSize='24px' fontWeight='500'/>
                </SocialButton >
                <SocialButton  label={'Instagram'} href={'#'}>
                  <FaInstagram fontFamily='Duplicate Sans' fontSize='24px' fontWeight='500'/>
                </SocialButton>
              </Stack>
              <Link></Link>
            </Stack>
            <Stack align='flex-start'>
              <ListHeader color='#A0A4A8 !important' >Product</ListHeader>
              <Link href={'#'}>About us</Link>
              <Link href={'#'}>Blog</Link>
            </Stack>
            <Stack align={'flex-start'}>
              <ListHeader color='#A0A4A8'>Usecase</ListHeader>
              <Link href={'#'}>Help Center</Link>
              <Link href={'#'}>Terms of Service</Link>
              <Link href={'#'}>Legal</Link>
            </Stack>
            <Stack align={'flex-start'}>
              <ListHeader color='#A0A4A8'>Company</ListHeader>
              <Link href={'#'}>Help Center</Link>
              <Link href={'#'}>Terms of Service</Link>
              <Link href={'#'}>Legal</Link>
            </Stack>
            <Stack align={'flex-start'}>
              <ListHeader color='#A0A4A8'>Resource</ListHeader>
              <Link href={'#'}>Help Center</Link>
              <Link href={'#'}>Terms of Service</Link>
            </Stack>
            <Stack align={'flex-start'}>
              <ListHeader color='#A0A4A8'>Legal</ListHeader>
              <Link href={'#'}>Privacy Policy</Link>
              <Link href={'#'}>Satus</Link>
            </Stack>
            
          </Grid>
        </Container>
      </Box>
    );
  }